module.exports = __webpack_public_path__ + "static/blink-dog-mtg-afr-fb24a073d562ade1d9f6751a11215662.jpg";